import { AlertCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface WikiGenerationBannerProps {
  status: 'in_progress' | 'failed';
  onRetry?: () => void;
}

export const WikiGenerationBanner = ({
  status,
  onRetry,
}: WikiGenerationBannerProps) => {
  if (status === 'in_progress') {
    return (
      <div
        className={cn(
          'flex items-center justify-between rounded-lg bg-zinc-900 px-4 py-3',
          'animate-in fade-in slide-in-from-top-1 duration-300',
        )}
      >
        <div className="flex items-center gap-2.5">
          <span className="h-2 w-2 rounded-full bg-white animate-pulse" />
          <span className="text-sm font-medium text-white">
            Generating wiki...
          </span>
        </div>

        <span className="text-xs text-zinc-400">
          This may take a moment
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex items-center justify-between rounded-lg border border-red-100 bg-red-50 px-4 py-3',
        'animate-in fade-in slide-in-from-top-1 duration-300',
      )}
    >
      <div className="flex items-center gap-2">
        <AlertCircle className="h-4 w-4 text-red-600" />
        <span className="text-sm font-medium text-red-700">
          Generation failed
        </span>
      </div>

      {onRetry && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onRetry}
          className="text-red-600 hover:text-red-700 hover:bg-red-100"
        >
          Retry
        </Button>
      )}
    </div>
  );
};
